// extracted by mini-css-extract-plugin
module.exports = {"player_wrapper":"wave-player-progress_player_wrapper__BGILi","waveform":"wave-player-progress_waveform__apVzO","time":"wave-player-progress_time__7MPYE"};